export enum ReminderChannel {
  EMAIL = 1,
  WHATSAPP = 2,
  VOICE = 3,
  SMS = 4,
}
